// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3b2bd2cf","264":"9439a3b6","448":"9cdc49ed","536":"418c097b","977":"39ec8ae2"}[chunkId] + ".chunk.js";
};